
<div class="col-md-12">
  <div class="col-lg-12 nopadding">
    <app-filter-panel [isAddFilter]=false [DefaultFilterArray]="DefaultFilterArray"
      (FilterEvent)="FilterApplyFilterEvent($event)"
      [isDatefilterDropdown]="true">
    </app-filter-panel>
  </div>
  <br/>
  <div class="col-lg-12 nopadding">
    <div class="ui-widget-header-1 nopadding">
      <div class="ui-grid-col-12 btnPanel">
        <label for="caissummary">
          <button pButton id="caissummary" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 1 ? 'optedBtnColor' : '')" label="CAIS Processing" (click)="getOptedTab(1, 'CAIS Processing')" class="button btn-lg innerScreenTabBtn cais-recon-button"></button>
        </label>
        <label for="caissubmission">
          <button pButton id="caissubmission" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 2 ? 'optedBtnColor' : '')" label="CAIS Submission" (click)="getOptedTab(2, 'CAIS Submission')" class="button btn-lg innerScreenTabBtn cais-recon-button"></button>
        </label>
    </div>
  </div>
</div>
<br/>
<div class="col-lg-12 nopadding">&nbsp;</div>
<!-- CAIS Processing Tab -->
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSummaryTab ? 'notdisplay': '')">
    <div class="row">
      <!-- Client Data Summary -->
      <div class="col-lg-4 tbpadding">
        @if(isCAISClientDataSummaryLoadingResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        }
        <!-- Grid Code  -->
        <p-table #dt 
          [value]="caisClientDataSet"
          [columns]="CaisClientDataSummaryCols"
          [resizableColumns]="true"
          [lazy]="true"
          appendTo="body">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              @if(caisClientDataSet.length === 0){
              <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                {{constantService.NO_RECORDFOUND_MSG}}
              </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of columns; track col.header + '-'+ $index) {
              <th id="columns" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [ngClass]="'ui-widget-NoUpdated-row'">
              @for(col of columns; track col.field + '-'+ $index) {
              <td class="text-center bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': ''">
                <span [ngClass]="col.header==='Accepted' ? 'successText' : (col.header==='Rejected' ? 'failText' : '')">
                  {{row[col.field]}}
                </span>
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- File Processing Summary -->
      <div class="col-lg-8 tbpadding">
        @if(isCAISFileProcessingSumaryLoadingResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        }
        <!-- Grid Code  -->
        <p-table #dt 
          [value]="caisProcessedFileDataSet"
          [columns]="CaisFileProcessingSummaryCols"
          [resizableColumns]="true"
          [lazy]="true"
          appendTo="body">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              @if(caisProcessedFileDataSet.length === 0){
              <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                {{constantService.NO_RECORDFOUND_MSG}}
              </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of columns; track col.header + '-'+ $index) {
              <th id="columns" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [ngClass]="'ui-widget-NoUpdated-row'">
              @for(col of columns; track col.field + '-'+ $index) {
              <td [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (col.header==='File Name' ? 'text-left bold-txt' : 'text-center bold-txt')">
                <span [ngClass]="col.header==='Good Count' ? 'successText' : (col.header==='Rejected Count' ? 'failText' : '')">
                  {{row[col.field]}}
                </span>
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSummaryTab ? 'notdisplay': '')">&nbsp;</div>

  <!-- Detail Breakdown by Exception Code -->
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSummaryTab ? 'notdisplay': '')">
    @if(isCAISExceptionCodeDetailLoadingResults){
    <div class="example-loading-shade">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    }
    <!-- Grid Code -->
    <p-table #dt 
      [value]="caisExceptionCodeDetailDataSet"
      [columns]="CaisDetailByExceptionCodeCols"
      [resizableColumns]="true"
      [lazy]="true"
      appendTo="body"
      responsiveLayout="scroll">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(caisExceptionCodeDetailDataSet.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col.header + '-'+ $index) {
          <th id="columns" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
            {{col.header}}
          </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="'ui-widget-NoUpdated-row'">
          @for(col of columns; track col.field + '-'+ $index; let i = $index) {
          <td class="bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (['File Name'].includes(col.header) ? 'text-left' : 'text-center')">
            <span [ngClass]="((i===columns.length-1) || (i!=0 && rowIndex===caisExceptionCodeDetailDataSet.length-1) ? 'failText' : '')">
              {{row[col.field]}}
            </span>
          </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSummaryTab ? 'notdisplay': '')">&nbsp;</div>
<!-- End of CAIS Processing Tab -->

<!-- CAIS Submission Tab -->
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSubmissionTab ? 'notdisplay': '')">
    <div class="row">
      <!-- Client Data Summary -->
      <div class="col-lg-4 tbpadding">
        @if(isCAISClientDataSummaryLoadingResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        }
        <!-- Grid Code -->
        <p-table #dt 
          [value]="caisClientDataSet"
          [columns]="CaisClientDataSummaryCols"
          [resizableColumns]="true"
          [lazy]="true"
          appendTo="body">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              @if(caisClientDataSet.length === 0){
              <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                {{constantService.NO_RECORDFOUND_MSG}}
              </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of columns; track col.header + '-'+ $index) {
              <th id="columns" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [ngClass]="'ui-widget-NoUpdated-row'">
              @for(col of columns; track col.field + '-'+ $index) {
              <td class="text-center bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': ''">
                <span [ngClass]="col.header==='Accepted' ? 'successText' : (col.header==='Rejected' ? 'failText' : '')">
                  {{row[col.field]}}
                </span>
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- Generation Summary -->
      <div class="col-lg-8 tbpadding">
        @if(isCAISGenerationSubmissionSummaryLoadingResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        }
        <!-- Grid Code  -->
        <p-table #dt 
          [value]="caisGenerationSubmissionDataSet"
          [columns]="caisGenerationSubmissionSummaryCols"
          [resizableColumns]="true"
          [lazy]="true"
          appendTo="body">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              @if(caisGenerationSubmissionDataSet.length === 0){
              <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                {{constantService.NO_RECORDFOUND_MSG}}
              </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of columns; track col.header + '-'+ $index) {
              <th id="columns" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [ngClass]="'ui-widget-NoUpdated-row'">
              @for(col of columns; track col.field + '-'+ $index) {
              <td class="bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (col.header === 'File Name' ? 'text-left' : 'text-center')">
                <span>
                  {{row[col.field]}}
                </span>
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSubmissionTab ? 'notdisplay': '')">&nbsp;</div>

  <!-- Submission Details -->
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSubmissionTab ? 'notdisplay': '')">
    <div class="row">
      <!-- Submission Data Summary -->
      <div class="col-lg-4 tbpadding">
        @if(isCaisSubmissionDataLoadingResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        }
        <!-- Grid Code -->
        <p-table #dt 
          [value]="caisSubmissionDataSet"
          [columns]="CaisSubmissionDataSummaryCols"
          [resizableColumns]="true"
          [lazy]="true"
          appendTo="body">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              @if(caisSubmissionDataSet.length === 0){
              <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                {{constantService.NO_RECORDFOUND_MSG}}
              </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of columns; track col.header + '-'+ $index) {
              <th id="colHeader" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [ngClass]="'ui-widget-NoUpdated-row'">
              @for(col of columns; track col.field + '-'+ $index) {
              <td class="text-center bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': ''">
                <span [ngClass]="col.header==='Accepted' ? 'successText' : (col.header==='Rejected' ? 'failText' : '')">
                  {{row[col.field]}}
                </span>
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-lg-8 tbpadding">
        @if(isCaisSubmissionDetailsLoadingResults){
        <div class="example-loading-shade">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        }
        <!-- Grid Code -->
        <p-table #dt 
          [value]="caisSubmissionDetailDataSet"
          [columns]="CaisSubmissionDetailSummaryCols"
          [resizableColumns]="true"
          [lazy]="true"
          appendTo="body">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              @if(caisSubmissionDetailDataSet.length === 0){
              <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                {{constantService.NO_RECORDFOUND_MSG}}
              </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for(col of columns; track col.header + '-'+ $index) {
              <th id="colHeader" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                {{col.header}}
              </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
            <tr [ngClass]="'ui-widget-NoUpdated-row'">
              @for(col of columns; track col.field + '-'+ $index) {
              <td class="bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (col.header === 'File Name' ? 'text-left' : 'text-center')">
                <span [ngClass]="(col.header==='Rejection Count' ? 'failText' : '')">
                  {{row[col.field]}}
                </span>
              </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <div class="col-lg-12 nopadding" [ngClass]="(!CAISSubmissionTab ? 'notdisplay': '')">&nbsp;</div>
<!-- End of CAIS Submission Tab -->